import initialState from './initialState';
import {
  ADD_NEW_ACCOUNT_ADMIN,
  ADD_NEW_ACCOUNT_ADMIN_DONE,
  ADD_NEW_ACCOUNT_ADMIN_ERROR,
  ADD_NEW_ACCOUNT_ADMIN_LOADING,
  ADD_NEW_ACCOUNT_ADMIN_SUCCESS,
  FETCH_ACCOUNT_ADMIN,
  FETCH_ACCOUNT_ADMIN_DONE,
  FETCH_ACCOUNT_ADMIN_ERROR,
  FETCH_ACCOUNT_ADMIN_LOADING,
  FETCH_ACCOUNT_ADMIN_SUCCESS,
  REMOVE_ACCOUNT_ADMIN,
  REMOVE_ACCOUNT_ADMIN_DONE,
  REMOVE_ACCOUNT_ADMIN_ERROR,
  REMOVE_ACCOUNT_ADMIN_LOADING,
  REMOVE_ACCOUNT_ADMIN_SUCCESS
} from '../actions/actionTypes';

// handles Account Administrator list related actions

const reducerAccountAdmin = (state, action) => {
  switch (action.type) {
    case FETCH_ACCOUNT_ADMIN_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_ACCOUNT_ADMIN_SUCCESS:
      return {
        ...state,
        admins: action.admins,
        error: null
      };
    case FETCH_ACCOUNT_ADMIN_ERROR:
      return {
        ...state,
        admins: null,
        error: action.error
      };
    case FETCH_ACCOUNT_ADMIN_DONE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};

const reducerAddNewAccountAdmin = (state, action) => {
  switch (action.type) {
    case ADD_NEW_ACCOUNT_ADMIN_LOADING:
      return {
        ...state,
        addLoading: true,
        addErrors: null,
        addError: null
      };
    case ADD_NEW_ACCOUNT_ADMIN_SUCCESS:
      return {
        ...state,
        admins: action.admins.all_users,
        addErrors: action.admins.errors,
        addError: null
      };
    case ADD_NEW_ACCOUNT_ADMIN_ERROR:
      return {
        ...state,
        addErrors: null,
        addError: action.error
      };
    case ADD_NEW_ACCOUNT_ADMIN_DONE:
      return {
        ...state,
        addLoading: false
      };
    default:
      return state;
  }
};

const reducerRemoveAccountAdmin = (state, action) => {
  switch (action.type) {
    case REMOVE_ACCOUNT_ADMIN_LOADING:
      return {
        ...state,
        removeLoading: true,
        removeError: null
      };
    case REMOVE_ACCOUNT_ADMIN_SUCCESS:
      return {
        ...state,
        admins: action.admins,
        removeError: null
      };
    case REMOVE_ACCOUNT_ADMIN_ERROR:
      return {
        ...state,
        removeError: action.error
      };
    case REMOVE_ACCOUNT_ADMIN_DONE:
      return {
        ...state,
        removeLoading: false
      };
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  if (action.type.startsWith(FETCH_ACCOUNT_ADMIN)) {
    return reducerAccountAdmin(state, action);
  } else if (action.type.startsWith(ADD_NEW_ACCOUNT_ADMIN)) {
    return reducerAddNewAccountAdmin(state, action);
  } else if (action.type.startsWith(REMOVE_ACCOUNT_ADMIN)) {
    return reducerRemoveAccountAdmin(state, action);
  } else {
    return state;
  }
};
